import { render, staticRenderFns } from "./right-arrow.vue?vue&type=template&id=51f187aa&scoped=true&v-once=true"
import script from "./right-arrow.vue?vue&type=script&lang=js"
export * from "./right-arrow.vue?vue&type=script&lang=js"
import style0 from "./right-arrow.vue?vue&type=style&index=0&id=51f187aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f187aa",
  null
  
)

export default component.exports